"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = void 0;
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ItemPipes = require("./ItemPipes");
var _HotSpotBox = _interopRequireDefault(require("../Models/HotSpotBox"));
var _Device = _interopRequireDefault(require("../Models/Device"));
var _constants = require("../../../utils/constants");
var _ItemPipesByIdentifier = require("./ItemPipesByIdentifier");
var _useGetComponentsByParams = require("../../../hooks/store/useGetComponentsByParams");
var _Types = require("../../../Types");
var _functions = require("../../../utils/functions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  sensorTypes,
  SectionTypes,
  LoopType,
  ComponentTypes
} = _paulCorePackage.constants;
const Item = exports.Item = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    equipmentId,
    position = [0, 0, 0],
    connectWithNext
  } = _ref;
  const type = ComponentTypes.HtgHx;
  const {
    thingHtgHxHydraulicCircuit: identifierTypeKey = -1
  } = (0, _useGetComponentsByParams.useGetComponentByTypeAndId)({
    type,
    id: equipmentId
  }) || {};
  // const { thingHtgHxHydraulicCircuit: identifierTypeKey = -1 } = {
  //   thingHtgHxHydraulicCircuit: 1,
  // };

  const showBox = false;
  const isKey = (0, _functions.isSomeComponentTypeKey)(identifierTypeKey);
  return /*#__PURE__*/_react.default.createElement("group", {
    position: position
  }, /*#__PURE__*/_react.default.createElement(_ItemPipes.ItemPipes, {
    isSplitPipes: connectWithNext
  }), /*#__PURE__*/_react.default.createElement("group", {
    position: [connectWithNext ? -_constants.spaseBetweenPipesByColInEquipmentItem : 0, 0, 0]
  }, /*#__PURE__*/_react.default.createElement(_ItemPipesByIdentifier.ItemPipesByIdentifier, {
    identifierTypeKey: Number(identifierTypeKey)
  }), /*#__PURE__*/_react.default.createElement("group", {
    position: [0, 2 * _constants.verticalPipeSpacing, 0]
  }, /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, 0, -8],
    showBox: showBox,
    pipe: _constants.pipesTypes.heatingFlow
  }, /*#__PURE__*/_react.default.createElement(_Device.default, {
    equipmentType: type,
    equipmentId: equipmentId,
    thingLoopType: LoopType.secondary,
    thingSectionType: SectionTypes.flow,
    requiredTypeNot: sensorTypes.pump
    // requiredType={sensorTypes.energyValve}
    // anywayShow
    ,
    modelProps: {
      [sensorTypes.energyValve]: {
        activeCable: _constants.activeCableDirection.bottom,
        deviceRotate: [0, 0, Math.PI],
        scale: [1, -1, 1]
      }
    },
    panelProps: {
      secondPosition: _constants.panelPosition.bottom
    }
  })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, 0, -21],
    showBox: showBox,
    pipe: _constants.pipesTypes.heatingFlow
  }, /*#__PURE__*/_react.default.createElement(_Device.default, {
    equipmentType: type,
    equipmentId: equipmentId,
    thingLoopType: LoopType.secondary,
    thingSectionType: SectionTypes.flow,
    requiredType: sensorTypes.pump,
    anywayShow: true
  })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, 0, -44],
    showBox: showBox,
    pipe: _constants.pipesTypes.heatingFlow
  }, /*#__PURE__*/_react.default.createElement(_Device.default, {
    equipmentType: type,
    equipmentId: equipmentId,
    thingLoopType: LoopType.primary,
    thingSectionType: SectionTypes.flow
    // requiredType={sensorTypes.energyValve}
    // anywayShow
    ,
    modelProps: {
      [sensorTypes.energyValve]: {
        activeCable: _constants.activeCableDirection.bottom,
        deviceRotate: [0, 0, Math.PI],
        scale: [1, -1, 1]
      }
    },
    panelProps: {
      secondPosition: _constants.panelPosition.bottom
    }
  })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, 0, -33],
    showBox: showBox,
    pipe: _constants.pipesTypes.heatingFlow,
    visible: isKey([_constants.htgHxConfig.mixingCircuit, _constants.htgHxConfig.mixingCircuitWithFixedBypass])
  }, /*#__PURE__*/_react.default.createElement(_Device.default, {
    equipmentType: type,
    equipmentId: equipmentId,
    thingLoopType: LoopType.none,
    thingSectionType: SectionTypes.flow,
    requiredType: sensorTypes.mixerValve,
    anywayShow: true,
    panelProps: {
      secondPosition: _constants.panelPosition.bottom
    }
  }))), /*#__PURE__*/_react.default.createElement("group", {
    position: [0, _constants.verticalPipeSpacing, 0]
  }, /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, 0, -8],
    showBox: showBox,
    pipe: _constants.pipesTypes.heatingReturn
  }, /*#__PURE__*/_react.default.createElement(_Device.default, {
    equipmentType: type,
    equipmentId: equipmentId,
    thingLoopType: LoopType.secondary,
    thingSectionType: SectionTypes.return
    // requiredType={sensorTypes.energyValve}
    // anywayShow
    ,
    modelProps: {
      [sensorTypes.energyValve]: {
        activeCable: _constants.activeCableDirection.top,
        deviceRotate: [0, 0, Math.PI],
        scale: [1, -1, 1]
      }
    },
    panelProps: {
      secondPosition: _constants.panelPosition.top
    }
  })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, 0, -44],
    showBox: showBox,
    pipe: _constants.pipesTypes.heatingReturn
  }, /*#__PURE__*/_react.default.createElement(_Device.default, {
    equipmentType: type,
    equipmentId: equipmentId,
    thingLoopType: LoopType.primary,
    thingSectionType: SectionTypes.return
    // requiredType={sensorTypes.energyValve}
    // anywayShow
    ,
    modelProps: {
      [sensorTypes.energyValve]: {
        activeCable: _constants.activeCableDirection.top,
        deviceRotate: [0, 0, Math.PI],
        scale: [1, -1, 1]
      }
    },
    panelProps: {
      secondPosition: _constants.panelPosition.top
    }
  })), /*#__PURE__*/_react.default.createElement(_HotSpotBox.default, {
    position: [0, 0, -33],
    showBox: showBox,
    pipe: _constants.pipesTypes.heatingReturn,
    visible: isKey([_constants.htgHxConfig.deflectionAndDistributionCircuit, _constants.htgHxConfig.injectionCircuitWith3wayValve])
  }, /*#__PURE__*/_react.default.createElement(_Device.default, {
    equipmentType: type,
    equipmentId: equipmentId,
    thingLoopType: LoopType.none,
    thingSectionType: SectionTypes.return,
    requiredType: sensorTypes.mixerValve,
    anywayShow: true,
    panelProps: {
      secondPosition: _constants.panelPosition.top
    }
  })))));
}, function () {
  let prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return prev.equipmentId === next.equipmentId && prev.position === next.position && prev.connectWithNext === next.connectWithNext;
});
Item.propTypes = {
  equipmentId: _propTypes.default.string,
  connectWithNext: _propTypes.default.bool,
  position: _Types.VectorType
};